export { default } from "@casino/client/hooks/useClientTranslations";
